// src/pages/Terms/TermsPage.js
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useLanguage } from '../../contexts/LanguageContext';
import './TermsPage.css';

const TermsPage = () => {
  const [markdownContent, setMarkdownContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { language } = useLanguage();
  
  // Determine which markdown file to load based on language
  const markdownFile = language === 'en' ? '/markdown/terms-en.md' : '/markdown/terms.md';

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(markdownFile);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch terms: ${response.status}`);
        }
        
        const text = await response.text();
        setMarkdownContent(text);
      } catch (err) {
        console.error('Error fetching terms markdown:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMarkdown();
  }, [markdownFile, language]);

  if (isLoading) {
    return (
      <div className="terms-container">
        <div className="terms-loading">
          <div className="loading-spinner"></div>
          <p>Loading terms of service...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="terms-container">
        <div className="terms-error">
          <h2>Error loading terms</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Try Again</button>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-container">
      <div className="terms-content">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    </div>
  );
};

export default TermsPage;